import React from 'react'

import Image from '../components/Image'
import Layout from '../components/Layout'
import Paper from '../components/Paper'
import SEO from '../components/Seo'
import Typography from '../components/Typography'

import BannerContainer from '../pageComponents/home/BannerContainer'
import Pictures from '../pageComponents/home/Pictures'
import compStyles from '../pageComponents/home/home.module.scss'

class HomePage extends React.Component {
 
  render () {
    return (
    <Layout>
      <SEO title='ಸತ್ಯಂಶಿವಂ ಸೇವಾ ಸಂಸ್ಥೆ' />
      <BannerContainer />
      <Paper>
        <Typography variant="h2" className={compStyles.about__heading}>ಸಂಸ್ಥೆಯ ಬಗ್ಗೆ ಒಳನೋಟ</Typography>
        <Typography variant="body1" className={compStyles.about__description}>
          ಮಾನ್ಯರೆ, ಮೇಲ್ಕಂಡ ಸತ್ಯ ಶಿವಂ ಸೇವಾ ಸಂಸ್ಥೆಯನ್ನು ನಾವು ಪ್ರಾರಂಭ ಮಾಡಿ ನೋಂದಣಿ ಮಾಡಲಾಗಿದೆ. ನಮ್ಮ ಸಂಸ್ಥೆಯ ವತಿಯಿಂದ ಹಿಂದೂ ಧಾರ್ಮ ಜಾಗೃತಿ, ಸಾಂಸ್ಕೃತಿಕ ಚಟುವಟಿಕೆಗಳು ಬಡ ವಿದ್ಯಾರ್ಥಿಗಳಿಗೆ ಸಹಾಯ, ವೃದ್ಧರು ಮತ್ತು ವಿಕಲಚೇತನರಿಗೆ ಸಹಾಯ ಹಸ್ತ, ಗೋಶಾಲೆಗಳಿಗೆ ಸಹಾಯ ಹಸ್ತ, ಬೆಂಗಳೂರಿನ ನಿವಾಸಿಗಳಿಗೆ ವಿವಿಧ ಇಲಾಖೆಯಿಂದ ಮೂಲ ಸೌಕರ್ಯಗಳಾದ ನೀರು ಮತ್ತು ಚರಂಡಿ ಸಮಸ್ಯೆ, ವಿದ್ಯುತ್ ಸಮಸ್ಯೆ, ಇನ್ನಿತರ ಸಮಸ್ಯೆಗಳು ಉಂಟಾದಾಗ ಆ ಬಗ್ಗೆ ಸಂಸ್ಥೆಯ ವತಿಯಿಂದ ಸಂಘಟಿತ ಪರಿಹಾರ ಕ್ರಮವನ್ನು ವಿವಿಧ ಇಲಾಖೆಯಲ್ಲಿ ವ್ಯವಹರಿಸಿ ಪರಿಹಾರ ಮಾಡುವ ಪ್ರಯತ್ನ ಈ ಸಂಸ್ತೆಯದ್ಹಾಗಿದೆ.
        </Typography>
      </Paper>
      <div style={{ width: '100%', backgroundColor: '#f7f0e3' }}>
        <div className={compStyles.seperator} style={{ width: '300px', margin: 'auto' }}><Image imageName="border1"/></div>
      </div>
      <Paper>
        <Typography variant="h2" className={compStyles.about__heading}>ಚಿತ್ರ ಪಟಗಳು</Typography>
        <Pictures />
        <Typography variant="body2" className={compStyles.viewmore}><a href='/pictures'>ಹೆಚ್ಚು ವೀಕ್ಷಿಸಿ</a></Typography>
      </Paper>
    </Layout>
    )
  }
}

export default HomePage
